(function(){
  'use strict';
  var A = window.AURELLE || {};

  function money(cents){
    var fmt = A.moneyFormat || '€{{amount_with_comma_separator}}';
    var v = (cents/100);
    var withComma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withDot = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k === 'amount_with_comma_separator') return withComma;
      if (k === 'amount_no_decimals') return Math.round(v).toString();
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withDot;
    });
  }
  A.money = money;

  /* ---------- Countdown (real deadline from theme settings) ---------- */
  function initCountdowns(){
    document.querySelectorAll('[data-countdown]').forEach(function(el){
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var hideTarget = el.closest('[data-countdown-wrap]') || el;
      function tick(){
        var d = end - Date.now();
        if (d <= 0){ hideTarget.hidden = true; return false; }
        var s = Math.floor(d/1000);
        var parts = { d: Math.floor(s/86400), h: Math.floor(s%86400/3600), m: Math.floor(s%3600/60), s: s%60 };
        Object.keys(parts).forEach(function(k){
          var n = el.querySelector('[data-cd="'+k+'"]');
          if (n) n.textContent = String(parts[k]).padStart(2,'0');
        });
        return true;
      }
      if (tick()) setInterval(tick, 1000);
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  function openDrawer(){ if(!drawer) return; drawer.classList.add('is-open'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ if(!drawer) return; drawer.classList.remove('is-open'); document.body.style.overflow=''; }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
    var t = e.target.closest('[data-drawer-open]');
    if (t && drawer){ e.preventDefault(); refreshCart().then(openDrawer); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeDrawer(); closeModals(); } });

  function esc(s){ var d=document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function renderCart(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(n){ n.textContent = cart.item_count; });
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-body]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    if (!cart.items.length){
      body.innerHTML = '<p class="empty">'+esc(A.t.empty)+'</p>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function(it){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      var orig = it.original_line_price > it.final_line_price ? '<s style="color:#aaa;margin-right:4px">'+money(it.original_line_price)+'</s>' : '';
      return '<div class="drawer__item">'+
        (img ? '<img src="'+img+'" alt="" width="70" height="70" loading="lazy">' : '<span></span>')+
        '<div><a href="'+it.url+'"><b>'+esc(it.product_title)+'</b></a>'+
        (it.variant_title ? '<small>'+esc(it.variant_title)+'</small>' : '')+
        '<small>× '+it.quantity+'</small>'+
        '<button type="button" data-remove="'+it.key+'">'+esc(A.t.remove)+'</button></div>'+
        '<div style="text-align:right">'+orig+'<b>'+money(it.final_line_price)+'</b></div></div>';
    }).join('');
    foot.querySelector('[data-drawer-total]').textContent = money(cart.total_price);
    var prog = foot.querySelector('[data-ship-progress]');
    if (prog){
      var goal = parseInt(prog.getAttribute('data-goal'),10) || 0;
      var left = goal - cart.total_price;
      var bar = prog.querySelector('span');
      var txt = prog.querySelector('[data-ship-text]');
      if (goal <= 0){ prog.hidden = true; }
      else if (left > 0){
        txt.innerHTML = prog.getAttribute('data-left').replace('[amount]', '<b>'+money(left)+'</b>');
        bar.style.width = Math.min(100, cart.total_price/goal*100)+'%';
      } else {
        txt.innerHTML = prog.getAttribute('data-done');
        bar.style.width = '100%';
      }
    }
  }
  function refreshCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ renderCart(c); return c; });
  }
  if (drawer){
    drawer.addEventListener('click', function(e){
      var b = e.target.closest('[data-remove]');
      if (!b) return;
      fetch(A.routes.cartChange, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id: b.getAttribute('data-remove'), quantity: 0})})
        .then(function(r){return r.json();}).then(renderCart);
    });
  }

  /* ---------- Modals ---------- */
  function closeModals(){ document.querySelectorAll('.modal.is-open').forEach(function(m){ m.classList.remove('is-open'); }); }
  document.addEventListener('click', function(e){
    var o = e.target.closest('[data-modal-open]');
    if (o){ var m = document.getElementById(o.getAttribute('data-modal-open')); if (m) m.classList.add('is-open'); }
    if (e.target.closest('[data-modal-close]')) closeModals();
  });

  /* ---------- Product ---------- */
  function initProduct(root){
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('[data-product-form]');
    var idInput = form.querySelector('[name="id"]');
    var atcBtns = document.querySelectorAll('[data-atc]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saveEl = root.querySelector('[data-save]');
    var badgeEl = root.querySelector('[data-badge-pct]');
    var stockEl = root.querySelector('[data-stock]');
    var selected = [];
    var current = product.variants.find(function(v){ return v.id == idInput.value; }) || product.variants[0];
    selected = current.options.slice();

    /* gallery */
    var slides = root.querySelectorAll('.gallery__slide');
    var thumbs = root.querySelectorAll('.thumbs__btn');
    var track = root.querySelector('.thumbs__track');
    function show(i){
      slides.forEach(function(s,k){ s.classList.toggle('is-active', k===i); });
      thumbs.forEach(function(t,k){ t.classList.toggle('is-active', k===i); });
      var t = thumbs[i];
      if (t && track) track.scrollTo({left: t.offsetLeft - track.clientWidth/2 + t.clientWidth/2, behavior:'smooth'});
      root.dataset.slide = i;
    }
    thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ show(i); }); });
    root.querySelectorAll('[data-thumb-nav]').forEach(function(b){
      b.addEventListener('click', function(){
        var cur = parseInt(root.dataset.slide||0,10);
        var n = (cur + parseInt(b.getAttribute('data-thumb-nav'),10) + slides.length) % slides.length;
        show(n);
      });
    });
    /* swipe on main */
    var main = root.querySelector('.gallery__main'), sx=null;
    if (main){
      main.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
      main.addEventListener('touchend', function(e){
        if (sx===null) return; var dx = e.changedTouches[0].clientX - sx; sx=null;
        if (Math.abs(dx) < 40) return;
        var cur = parseInt(root.dataset.slide||0,10);
        show((cur + (dx<0?1:-1) + slides.length) % slides.length);
      });
    }
    function showMedia(mediaId){
      if (!mediaId) return;
      slides.forEach(function(s,k){ if (s.getAttribute('data-media-id') == mediaId) show(k); });
    }

    function findVariant(opts){
      return product.variants.find(function(v){ return v.options.every(function(o,i){ return o === opts[i]; }); });
    }
    function availabilityFor(optIndex, value){
      var test = selected.slice(); test[optIndex] = value;
      var v = findVariant(test);
      return v && v.available;
    }

    function update(v){
      current = v;
      root.querySelectorAll('[data-opt-index]').forEach(function(group){
        var idx = parseInt(group.getAttribute('data-opt-index'),10);
        var lbl = root.querySelector('[data-opt-value="'+idx+'"]');
        if (lbl) lbl.textContent = selected[idx];
        group.querySelectorAll('[data-value]').forEach(function(b){
          var val = b.getAttribute('data-value');
          b.classList.toggle('is-active', val === selected[idx]);
          b.setAttribute('aria-pressed', val === selected[idx]);
          b.classList.toggle('is-unavailable', !availabilityFor(idx, val));
        });
      });
      if (!v){
        atcBtns.forEach(function(b){ b.disabled = true; b.querySelector('[data-atc-text]').textContent = A.t.unavailable; });
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      var hasCmp = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl){ compareEl.textContent = hasCmp ? money(v.compare_at_price) : ''; compareEl.hidden = !hasCmp; }
      if (saveEl){
        saveEl.hidden = !hasCmp;
        if (hasCmp) saveEl.querySelector('[data-save-amount]').textContent = money(v.compare_at_price - v.price);
      }
      if (badgeEl){
        var wrap = badgeEl.closest('.gallery__badge');
        if (hasCmp){ badgeEl.textContent = '-' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; if (wrap) wrap.hidden = false; }
        else if (wrap) wrap.hidden = true;
      }
      if (stockEl){
        stockEl.classList.toggle('is-out', !v.available);
        stockEl.textContent = v.available ? stockEl.getAttribute('data-in') : stockEl.getAttribute('data-out');
      }
      atcBtns.forEach(function(b){
        b.disabled = !v.available;
        var t = b.querySelector('[data-atc-text]');
        t.textContent = v.available ? A.t.add : A.t.soldout;
        var p = b.querySelector('[data-atc-price]');
        if (p) p.textContent = v.available ? '— ' + money(v.price * getQty()) : '';
      });
      document.querySelectorAll('[data-sticky-price]').forEach(function(n){ n.textContent = money(v.price); });
      document.querySelectorAll('[data-sticky-compare]').forEach(function(n){ n.textContent = hasCmp ? money(v.compare_at_price) : ''; });
      document.querySelectorAll('[data-sticky-variant]').forEach(function(n){ n.textContent = v.title === 'Default Title' ? '' : v.title; });
      if (v.featured_media) showMedia(v.featured_media.id);
      if (window.history.replaceState){
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    root.querySelectorAll('[data-opt-index]').forEach(function(group){
      var idx = parseInt(group.getAttribute('data-opt-index'),10);
      group.addEventListener('click', function(e){
        var b = e.target.closest('[data-value]'); if (!b) return;
        selected[idx] = b.getAttribute('data-value');
        var v = findVariant(selected);
        if (!v || !v.available){
          /* snap to closest available combination keeping this choice */
          var alt = product.variants.find(function(x){ return x.available && x.options[idx] === selected[idx]; });
          if (alt){ selected = alt.options.slice(); v = alt; }
        }
        update(v);
      });
    });

    /* quantity */
    var qtyInput = root.querySelector('[data-qty]');
    function getQty(){ return qtyInput ? Math.max(1, parseInt(qtyInput.value,10)||1) : 1; }
    root.querySelectorAll('[data-qty-step]').forEach(function(b){
      b.addEventListener('click', function(){
        qtyInput.value = Math.max(1, getQty() + parseInt(b.getAttribute('data-qty-step'),10));
        update(current);
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function(){ update(current); });

    function addToCart(){
      if (!current || !current.available) return;
      atcBtns.forEach(function(b){ b.classList.add('is-loading'); });
      fetch(A.routes.cartAdd, {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items: [{ id: current.id, quantity: getQty() }] })
      }).then(function(r){ return r.json(); }).then(function(res){
        if (res.status && res.description){ alertInline(res.description); return; }
        return refreshCart().then(openDrawer);
      }).catch(function(){ form.submit(); })
        .finally(function(){ atcBtns.forEach(function(b){ b.classList.remove('is-loading'); }); });
    }
    function alertInline(msg){
      var n = root.querySelector('[data-form-error]');
      if (n){ n.textContent = msg; n.hidden = false; setTimeout(function(){ n.hidden = true; }, 5000); }
    }
    form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(); });
    document.querySelectorAll('[data-sticky-atc] [data-atc]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); addToCart(); });
    });

    /* sticky ATC visibility */
    var sticky = document.querySelector('[data-sticky-atc]');
    var mainAtc = form.querySelector('[data-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var below = en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !en.isIntersecting && below);
        });
      }).observe(mainAtc);
    }

    update(current);
  }

  /* ---------- Review ticker ---------- */
  function initTickers(){
    document.querySelectorAll('[data-ticker]').forEach(function(t){
      var slides = t.querySelectorAll('.rticker__slide');
      var dots = t.querySelectorAll('.dots span');
      if (slides.length < 2) return;
      var i = 0;
      setInterval(function(){
        slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
        i = (i+1) % slides.length;
        slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
      }, 4500);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(){
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- Delivery estimate (business days) ---------- */
  function initDelivery(){
    document.querySelectorAll('[data-delivery]').forEach(function(el){
      var min = parseInt(el.getAttribute('data-min'),10)||2, max = parseInt(el.getAttribute('data-max'),10)||6;
      function addBiz(d, n){ var r = new Date(d); while(n>0){ r.setDate(r.getDate()+1); var w=r.getDay(); if(w!==0&&w!==6) n--; } return r; }
      var loc = document.documentElement.lang || 'fr';
      var opts = {weekday:'short', day:'numeric', month:'short'};
      var now = new Date();
      var a = addBiz(now, min).toLocaleDateString(loc, opts);
      var b = addBiz(now, max).toLocaleDateString(loc, opts);
      var out = el.querySelector('[data-delivery-range]');
      if (out) out.textContent = a + ' – ' + b;
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initCountdowns();
    initTickers();
    initReveal();
    initDelivery();
    document.querySelectorAll('[data-product]').forEach(initProduct);
  });
})();
